import 'Styles/page.scss';
import 'Styles/animate.scss';
import 'Styles/old_phones.scss'

import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { replace, push, goBack } from 'react-router-redux';

import isEqual from 'lodash/isEqual';

import Alert from 'react-s-alert';
import 'react-s-alert/dist/s-alert-default.css';
import 'react-s-alert/dist/s-alert-css-effects/stackslide.css';

import { initAdLibraries, getGeoLocation, trackPageView, onPageView } from 'Actions/adsActions';
import {
	sidebarOff, toggleSearchBar,
	toggleHeaderOverflow, hideReplyModal, hideLoginModal,
	hideUserModal, hideConfirmModal,
	hideShareModal, displayNotification
} from 'Actions/UiActions';
import { clearFirstLoad } from 'Actions/GlobalMetaActions';
import { receiveCurrentUser } from 'Actions/UstateActions';
import { getLandingPage } from 'Actions/UserSettingsActions';

import Header from 'Components/header/HeaderComponent';
import HeaderOverflow from 'Components/header/HeaderOverflowComponent';
import SearchBar from 'Components/header/SearchBarComponent';
import Sidebar from 'Components/common/SidebarComponent';
import LoginModal from 'Components/modals/LoginModalComponent';
import ConfirmModal from 'Components/modals/ConfirmModalComponent';
import ReplyModal from 'Components/modals/ReplyModalComponent';
import UserModal from 'Components/modals/UserModalComponent';
import ShareModal from 'Components/modals/ShareLinkComponent';
import AdComponent from 'Components/ads/AdComponent';
import Overlay from 'Components/common/overlayComponent';
import TopifyAlertTemplate from 'Components/alerts/alertsTemplate';
import Notices from 'Components/alerts/NoticesListComponent';

import uiSelector from 'Selectors/uiSelectors';
import ads from 'Selectors/ads';

import { deviceType, devicePlatform } from 'Utils/deviceType';

class PageComponent extends React.Component {
	constructor( props ) {
		super( props );

		this.deviceInfo = {};
		this.state = {
			viewportHeight: window.innerHeight - 48
		};
		this.currentScroll = 0;
		this.isOldPhone = this.checkOldPhone();
	}

	componentWillMount() {
		const { initialRoute, initialId, secondayId, routes, isVS } = this.props;

		// Get userInfo as soon as possible
		if( this.props.userInfo && this.props.userInfo.id ) {
			this.props.dispatch( receiveCurrentUser( this.props.userInfo ) );
		}

		let landingPagePath = this.props.dispatch( getLandingPage() );

		history.replaceState( null, '', location.href.replace( /rtemv=\d+/i, '' ).replace( /tfr=1/i, '' ) );

		// if we have an initial route from the forum but we don't have already a different path
		if(
			initialRoute &&
			!( routes.length > 1 && routes[ 1 ].path )
		) {
			if( initialRoute === 'portal' && parseInt( isVS ) !== 1 ) { // we only allow portal for VS sites
				this.props.dispatch( clearFirstLoad() );

			} else {
				let path = {
					pathname: initialRoute + "/" + initialId
				};
				if( secondayId ) {
					path.query = { postid: secondayId };
				}

				this.props.dispatch( push( path ) );
			}

		} else if( routes.length > 1 && routes[ 1 ].path ) {
			// Let's insert a step in history to the home page if we start on a page other than home
			// unless we are on 'localhost' env
			if( /localhost|192\.168\./.test( window.location.host ) === false ) {
				history.replaceState( null, '', this.props.forum_url );
				history.pushState( null, '', this.props.forum_url );
				this.props.dispatch( push( this.props.location ) );
			}

		} else if( landingPagePath !== this.props.location.pathname ) {
			// Go to the landingPage from UserSettings
			this.props.dispatch( push( landingPagePath ) );
		}

		// Ask for geoLocation
		this.props.dispatch( getGeoLocation() );

		// Init ads
		this.props.dispatch( initAdLibraries() );

		//handling webkit/flex styles for older ios devices
		this.deviceInfo = deviceType();

		topifyConsole.info( 'deviceInfo:', this.deviceInfo );
		document.body.classList.add( devicePlatform(), this.deviceInfo.browser.engine );
	}

	componentDidMount() {
		// If we have a message to show
		if( this.props.location.query.msg ) {
			displayNotification( ( this.props.location.query.msgtype || 'warning' ), this.props.location.query.msg, { timeout: 2000 } );
			// remove msg from the url
			delete this.props.location.query.msg;
			delete this.props.location.query.msgtype;
			this.props.dispatch( replace( this.props.location ) );
		}

		if( this.props.firstLoad ) {
			this.props.dispatch( clearFirstLoad() );
		}

		window.addEventListener( 'popstate', ( e ) => this.resetOverWindows( e ) );
		window.addEventListener( 'resize', () => this.getViewportHeight() );

		this.getViewportHeight();
	}

	componentWillReceiveProps( nextProps ) {
		if(
			nextProps.loginModalOpened ||
			nextProps.confirmModalOpened ||
			nextProps.globalLoading ||
			nextProps.headerOverflowOpened ||
			nextProps.searchBarOpened ||
			nextProps.userModalOpened ||
			nextProps.replyModalOpened ||
			nextProps.shareModalOpened ||
			nextProps.iOSkeyBoardOpen ||
			nextProps.announcementsOpen
		) {
			// Take the scroll position
			this.currentScroll = this.currentScroll || document.body.scrollTop;

			// Prevents page scrolling while modal is open
			document.body.classList.add( 'no-scroll' );
		} else {
			// Safely remove the class we added
			document.body.classList.remove( 'no-scroll' );

			// Only for iOS - Safari: we need to restore scroll position
			if( this.currentScroll > 0 && this.deviceInfo.os.platform.ios && this.deviceInfo.browser.engine === 'Safari' ) {
				document.body.scrollTop = this.currentScroll;
			}
			// clear scroll position
			this.currentScroll = 0;
		}

		// Track page view if it's the case
		if(
			nextProps.ads.analytics !== this.props.ads.analytics &&
			(
				nextProps.routing.locationBeforeTransitions.pathname === this.props.routing.locationBeforeTransitions.pathname &&
				nextProps.infiniteScrollPage !== this.props.infiniteScrollPage
			)
		) {
			// trigger ad updates
			this.props.dispatch( onPageView() );
			// Record the Google Analytics pageview
			this.props.dispatch( trackPageView() );
		}

	}

	shouldComponentUpdate( nextProps, nextState ) {
		return (
			nextProps.children !== this.props.children ||
			!isEqual( nextState, this.state ) ||
			nextProps.ads.showInterstitial !== this.props.ads.showInterstitial ||
			nextProps.userSettings.styleTheme !== this.props.userSettings.styleTheme ||
			nextProps.userSettings.fontSize !== this.props.userSettings.fontSize
		);
	}

	checkOldPhone = () => {
		//handling webkit/flex styles for older ios devices
		const deviceInfo = deviceType();

		return ( deviceInfo.any &&
			(
				( deviceInfo.os.platform.ios && deviceInfo.os.version < '9' ) ||
				(
					deviceInfo.os.platform.android &&
					(
						( deviceInfo.browser.engine === 'Safari' && parseInt( deviceInfo.browser.version ) <= 534 ) ||
						( deviceInfo.browser.engine === 'Chrome' && parseInt( deviceInfo.browser.version ) <= 37 )
					)
				)
			)
		);
	};

	getViewportHeight() {
		this.setState( { viewportHeight: window.innerHeight - 48 } );
	}

	resetOverWindows( e ) {
		if( this.props.confirmModalOpened ) {
			if( e.state && e.state.type === 'confirmModal' ) {
				topifyConsole.info( 'cleaning history ', e.state );
				this.props.dispatch( goBack() );
			}

			this.props.dispatch( hideConfirmModal() );
			return true;
		}

		// In some cases we have more than 1 extra entry in history, let's clean them up
		if( e.state && e.state.topifyExtra ) {
			topifyConsole.info( 'cleaning history ', e.state );
			this.props.dispatch( goBack() );
		}

		// Close any modal open
		if( this.props.headerOverflowOpened ) {
			this.props.dispatch( toggleHeaderOverflow() );
		}
		if( this.props.searchBarOpened ) {
			this.props.dispatch( toggleSearchBar() );
		}
		if( this.props.sidebarOpened ) {
			this.props.dispatch( sidebarOff() );
		}
		if( this.props.userModalOpened ) {
			this.props.dispatch( hideUserModal() );
		}
		if( this.props.loginModalOpened ) {
			this.props.dispatch( hideLoginModal() );
		}
		if( this.props.replyModalOpened ) {
			this.props.dispatch( hideReplyModal() );
		}
		if( this.props.shareModalOpened ) {
			this.props.dispatch( hideShareModal() );
		}

		return true;
	}

	interstitialAd() {
		if( this.props.ads.showInterstitial ) {
			return <AdComponent adType="4" adName="Interstitial_Ad"/>;
		} else {
			return null;
		}
	}

	render() {
		let style = this.props.userSettings.styleTheme ? ` style-${ this.props.userSettings.styleTheme }` : ' style-light',
			fontSize = this.props.userSettings.fontSize ? ` fontSize-${ this.props.userSettings.fontSize }` : ` fontSize-normal`,
			appClassNames = ( this.isOldPhone ? ' old_phones' : '' ) + style + fontSize;

		/**
		 * This means spacing between notifications.
		 * Note that since we reduce the padding of the alert (page.css -> .s-alert-wrapper)
		 * we need to adapt this spacing: ( ( <our padding top> - 22 ) * 2 ) + <the space we want>
		 * this way we have => ( ( 10 - 22 ) * 2 ) + 2) = -22
		 */
		let alertSpacing = -22;

		return (
			<div id="app" className={ appClassNames } style={ { minHeight: this.state.viewportHeight } }>
				<Alert
					stack={ { spacing: alertSpacing } }
					timeout={ 4000 }
					effect={ this.isOldPhone ? '' : 'stackslide' }
					position={ 'top' }
					html={ true }
					offset={ 2 }
					contentTemplate={ TopifyAlertTemplate }
				/>
				<Header />
				<SearchBar />
				<HeaderOverflow />
				<section id="page">
					<Notices />
					{ this.props.children }
					<div className="clearBottom" />
				</section>
				<AdComponent adType="3" className="bottom-fixed-ad" adName="Fixed_Bottom_Leaderboard" />
				<Sidebar />
				{/* Modal components don't necessarily have to be here, they could be located in sub components as well */}
				<LoginModal />
				<ConfirmModal />
				<ReplyModal />
				<UserModal />
				<ShareModal />
				<Overlay />
				{ this.interstitialAd() }
			</div>
		);
	}
}

PageComponent.propTypes = {
	initialRoute: PropTypes.string,
	initialId: PropTypes.string,
	secondayId: PropTypes.string
};

const mapStateToProps = ( state ) => {
	return {
		firstLoad: state.topifyPresets.firstLoad,
		initialRoute: state.topifyPresets.initialRoute,
		initialId: state.topifyPresets.initialId,
		secondayId: state.topifyPresets.secondayId,
		forum_url: state.topifyPresets.forumSite.f_url,
		isVS: state.topifyPresets.forumSite.isVS,
		userInfo: state.topifyPresets.userInfo,
		registerUrl: state.ustate.registerUrl,
		socialOptions: state.ustate.socialOptions,
		...uiSelector( state ),
		userSettings: state.ui.userSettings,
		ads: ads( state ),
		routing: state.routing,
		infiniteScrollPage: state.infiniteScroll.page
	};
};

export default connect( mapStateToProps )( PageComponent );


// WEBPACK FOOTER //
// ./src/components/PageComponent.js